module.exports = __webpack_public_path__ + "img/king_alpha.waxfun.7c88600.png";